import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const styles = theme => ({
  root: {
    // display: "flex",
    // flexDirection: "column",
    textAlign: "center",
    // justifyContent: "space-around",
    // alignItems: "flex-start",
    overflow: "auto",
    height: "100%",
    // minHeight: "100%",
    margin: "0 15px"
  },
  title: {
    margin: "15px 0"
    // color: theme.palette.primary.dark
  },
  content: {
    margin: "15px 0"
  },
  privacy: {
    marginTop: "15px"
  },
  reset: {
    marginTop: "15px"
  },
  logo: {
    maxWidth: "100px",
    width: "50%"
  }
});

class About extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired
  };

  handleClose = toReset => {
    if (toReset) {
      localStorage.clear();
      window.location.reload();
    }
    this.setState({ showResetDialog: false });
    // this.props.onClose(this.props.selectedValue);
  };

  state = {
    showResetDialog: false
  };

  render() {
    const { classes } = this.props;
    const { showResetDialog } = this.state;
    const currentVersion = localStorage.getItem("version");
    return (
      <div className={classes.root}>
        <Typography variant="title" className={classes.title} gutterBottom>
          Over het project
        </Typography>
        <div className={classes.content}>
          <Typography variant="body1" gutterBottom>
            Ontdek mooie fietsroutes en test de fiets-app van VRT Innovatie.
            Selecteer hoeveel km je wil fietsen, of je kassei- en/of zandwegen
            wilt vermijden en de app berekent voor jou een route langs het
            knooppuntennetwerk. Of ben je benieuwd naar welke route onze
            ambassadeurs aanbevelen? Neem een kijkje! Meer zelfs, op specifieke
            knooppunten kan je exclusieve historische VRT-fragmenten bekijken
            over de streek waar je fietst. Vertrekken maar!
          </Typography>
          <Typography variant="body1" gutterBottom>
            Deze webapplicatie maakt deel uit van het “CONAMO” project. CONAMO
            is een imec.icon onderzoeksproject, gesubsidieerd door imec en het
            Agentschap Innoveren &amp; Ondernemen, in samenwerking met de VRT.
            Het project ging van start op 1 oktober 2016 en loopt tot 30
            september 2018. Vind meer informatie op{" "}
            <a
              href="http://innovatie.vrt.be/conamo/"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://innovatie.vrt.be/conamo/
            </a>{" "}
            of{" "}
            <a
              href="https://www.iminds.be/en/projects/conamo"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.iminds.be/en/projects/conamo
            </a>.
          </Typography>
          <Typography variant="body1" gutterBottom>
            Deze testversie is mede in samenwerking met{" "}
            <a
              href="https://www.ugent.be/ea/idlab/en"
              target="_blank"
              rel="noopener noreferrer"
            >
              ID Lab UGent
            </a>{" "}
            en{" "}
            <a
              href="https://www.routeyou.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              RouteYou
            </a>.
          </Typography>
        </div>
        <div>
          <Button
            variant="raised"
            size="large"
            href="https://vrtenquete.typeform.com/to/xu4ztm"
            target="_blank"
            rel="noreferrer noopener"
            className={classes.button}
            onClick={this.startNavigation}
          >
            Geef feedback
          </Button>
        </div>

        <div>
          <Button
            variant="raised"
            size="large"
            className={classes.reset}
            onClick={() => this.setState({ showResetDialog: true })}
          >
            Reset
          </Button>
        </div>

        <Typography variant="body1" className={classes.privacy} gutterBottom>
          Lees hier de{" "}
          <a
            href="https://www.vrt.be/mijnprivacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            privacyverklaring
          </a>.
        </Typography>
        <img
          src="/images/VRT_Innovation_Logo_NL.png"
          alt="logo VRT Innovatie"
          className={classes.logo}
        />
        {currentVersion ? <div>versie 1.{currentVersion}</div> : null}
        <Dialog
          open={showResetDialog}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">App resetten</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Ben je zeker dat je de app wilt resetten? Dit kan je doen als de
              app vast zit. Het zal je gegenereerde route verwijderen.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleClose(false)} color="primary">
              Annuleren
            </Button>
            <Button
              onClick={() => this.handleClose(true)}
              color="primary"
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(About);



// WEBPACK FOOTER //
// ./src/NewRoute/components/About.js